module.exports = "h3 {\r\n  align:center;\r\n}\r\n"